import type { ButtonHTMLAttributes, ReactNode } from "react";

import { cn } from "@pontimed/ui";

interface FilterChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  active: boolean;
  children: ReactNode;
}

/**
 * Toggleable filter pill — same look as the /find filter pills (teal soft
 * when active), 44px tall for touch. One style for every account filter row
 * (HR leave, staff branches…).
 */
export function FilterChip({ active, className, children, type, ...props }: FilterChipProps) {
  return (
    <button
      type={type ?? "button"}
      aria-pressed={active}
      className={cn(
        "inline-flex min-h-11 shrink-0 items-center gap-1.5 rounded-full border px-4 text-sm font-medium transition-colors",
        "focus-visible:ring-ring/50 outline-none focus-visible:ring-3",
        active
          ? "border-primary/30 bg-primary-soft text-primary"
          : "border-border bg-card text-muted-foreground hover:bg-muted hover:text-foreground",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
